import { combineReducers } from 'redux';
import user from './user';
import cookies from './cookies';
import rpt from './rpt';
import file from './file';
import scrape from './scrape';
import calculations from './calculations';
// import profile from './profile'
// import flow from './flow'
import sharings from './sharings';
import penlyplay from './penlyplay';
import affiliates from './affiliates';
import pensiongoals from './pensiongoals';

const reducer = combineReducers({
    rpt,
    user,
    cookies,
    documentData: file,
    scrapeData: scrape,
    // profileData: profile,
    calculations,
    // flow,
    sharings,
    penlyplay,
    affiliates,
    pensiongoals,
});

export default reducer;
